<template>
  <b-form-group spellcheck="true" class="mb-1">
    <span class="text-muted fz-small" data-test="visibility-hint">{{ visibilityHint }}</span>
    <STextarea
      id="freetext-option-input"
      v-model="userAnswerOption"
      :validation-rules="`required|max:${maxCharacters}`"
      :validation-field-name="`value-${question.uuid}`"
      validation-field-label="value"
      class="mt-2"
      :rows="3"
      no-resize
      :label-text="$t('survey.create.free_text.survey_placeholder')"
      hide-label
      :placeholder="$t('survey.create.free_text.survey_placeholder')"
      data-cy="sdui-survey-freetext-input"
      @update:model-value="$emit('update', userAnswerOption)"
    />
    <b-button
      v-if="showOtherUsersFreeTextAnswers"
      class="w-100 text-right pr-0"
      variant="link"
      data-test="show-other-users-answers-btn"
      @click="showOtherUsersFreeTextAnswersModal = true"
    >
      {{ $t('survey.freetext_question.show_other_users_answers') }}
    </b-button>
    <SModal
      v-model="showOtherUsersFreeTextAnswersModal"
      :header-title="$t('survey.freetext_question.modal.title')"
      :show-footer-gradient="false"
    >
      <template v-if="showOtherUsersFreeTextAnswersModal">
        <h4 class="font-weight-bold gray-400 fz-base mb-3 mt-2" data-test="survey-question">
          {{ questionIndex }}: {{ question.question }}*
        </h4>
        <SList v-if="question.options.length">
          <SListItem
            v-for="answerOption in question.options"
            :key="answerOption.uuid"
            :title="answerOption.name"
            data-test="sdui-list-item"
          />
        </SList>
        <div v-else
             class="text-center text-muted small py-4"
             data-test="survey-option-empty-state"
        >
          {{ $t('survey.no_answers_yet') }}
        </div>
      </template>
    </SModal>
  </b-form-group>
</template>

<script>
import constants from 'src/config/constants.ts'

export default {
  name: 'SduiSurveyFreeTextVoting',
  props: {
    userHasVoted: {
      type: Boolean,
      default: false,
    },

    surveyVisibility: {
      type: String,
      default: constants.survey.resultsVisibility.NONE,
      validator: (value) => Object.keys(constants.survey.resultsVisibility).includes(value.toUpperCase()),
    },

    questionIndex: {
      type: Number,
      default: 1,
    },

    question: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    userAnswerOption: '',
    maxCharacters: constants.survey.maxCharacters,
    showOtherUsersFreeTextAnswersModal: false,
  }),

  computed: {
    visibilityHint() {
      return this.$t(
        this.surveyVisibility === constants.survey.resultsVisibility.NONE
          ? 'survey.freetext_question.visibility_hint_anonymous'
          : 'survey.freetext_question.visibility_hint_public',
      )
    },

    showOtherUsersFreeTextAnswers() {
      return !this.userHasVoted && this.surveyVisibility === constants.survey.resultsVisibility.BEFORE
    },
  },

  emits: ['update'],
}
</script>
